import { ResizeCallback } from '../utils/resize-callback'
import { EventBus } from '../core/smpl-components'
import { Events } from '../core/events'

// On touch devices the browser toolbar (Safari, Chrome Android) collapses and
// expands while scrolling, which changes innerHeight without any layout intent
// behind it. Treat those viewports as width-only: a real rotation always changes
// the width too, so orientation changes still come through.
const COARSE_POINTER = '(hover: none) and (pointer: coarse)'

// -----------------------------------------------------------------------------
// Resize — the single bridge from window resize to Events.PAGE_RESIZE.
//
// Subsystems listen to the EventBus, not to window: ScrollTriggerManager
// refreshes its triggers, scroll-parallax re-measures. Without this bridge
// PAGE_RESIZE only ever fired from content-height changes (faq-accordion,
// statistics-highlight) and never from an actual viewport change.
// -----------------------------------------------------------------------------
export const initResize = (ctx) => {
	// Kept live rather than read once, so hybrid devices are judged per resize.
	const coarsePointer = window.matchMedia(COARSE_POINTER)

	const resize = new ResizeCallback(
		({ changedAxis }) => {
			if (coarsePointer.matches && !changedAxis.includes('x')) return

			EventBus.emit(Events.PAGE_RESIZE)
		},
		{ delay: 150, resizeThreshold: 10 },
	)

	ctx.resize = resize
	return resize
}
